import {findID, listener} from "../../../../../../../modules/vegas/js/util";
import VGCartPromocode from "./promocode";
import Modal from "../../../../../../../modules/boot/js/modal.js";
import VGCatalogCart from "../cart/cart";

function listeners() {
	listener('submit', '#form-order-promocode', (el, e) => {
		e.preventDefault();

		let route = el.action;
		let code = el.querySelector('[name=code]').value;
		let params = {
			code: code
		};

		new VGCartPromocode().clearModalResult()

		axios.post(route, params).then((response) => {
			new VGCartPromocode().setModalResult(code, response.data);

			if (!response.data.error) {
				setTimeout(function () {
					Modal.getInstance(findID('modal-promocode')).hide();
				}, 1000);
			}
		});
	});

	listener('click', '.cart-promocode .btn-del-promocode', (el, e) => {
		new VGCartPromocode().clearCartPromocode();
		e.preventDefault();
	});

	listener('change', '.cart-promocode [name=promocode]', (el, e) => {
		new VGCatalogCart().update();
	});

	listener('show.bs.modal', '#modal-promocode', (el, e) => {
		let p = new VGCartPromocode();
		p.clearModalPromocode();
		p.clearModalResult();
	});
}

document.addEventListener('DOMContentLoaded', listeners);
